import { render, staticRenderFns } from "./SeqTab.vue?vue&type=template&id=b20126ac&"
import script from "./SeqTab.vue?vue&type=script&lang=js&"
export * from "./SeqTab.vue?vue&type=script&lang=js&"
import style0 from "./SeqTab.vue?vue&type=style&index=0&id=b20126ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports